import { useCallback, useEffect, useRef, useState } from "react";
import { getDriverMobileUseCase } from "../domain/usecases/getDriverMobileUseCase";

export function useDriverMobile(vehicleId) {
  const requestId = useRef(0);
  const [details, setDetails] = useState({
    driver: null,
    loading: false,
    error: "",
  });

  useEffect(() => () => { requestId.current += 1; }, []);

  const loadDriver = useCallback(async (driverId) => {
    const currentRequest = ++requestId.current;
    setDetails({ driver: null, loading: true, error: "" });
    const result = await getDriverMobileUseCase(driverId);
    if (currentRequest !== requestId.current) return;

    setDetails({
      driver: result.data,
      loading: false,
      error: result.error || "",
    });
  }, []);

  const vehicle = Number.isSafeInteger(vehicleId) && vehicleId > 0
    ? details.driver?.vehicles.find(({ id }) => id === vehicleId) || null
    : null;

  return { ...details, vehicle, loadDriver };
}
